import React from "react";

export default function CalendarIcon() {
  return (
    <React.Fragment>
      <svg
        width="16"
        height="18"
        viewBox="0 0 16 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13 0V2H14C15.1 2 16 2.96429 16 4.14286V15.8571C16 17.0357 15.1 18 14 18H2C0.89 18 0 17.0357 0 15.8571V4.14286C0 2.96429 0.89 2 2 2H3V0H5V2H11V0H13ZM14 4H2V16H14V4Z"
          fill="#1E2946"
        />
        <path
          d="M5.36575 8V6H11V7.5L8.9724 9.25618C9.65899 9.35773 10.1903 9.61342 10.5663 10.0232C10.9422 10.4331 11 10.9632 11 11.5C11 12.2979 10.8258 12.8666 10.2168 13.32C9.60789 13.7733 8.82936 14 7.88121 14C6.93306 14 5.97267 13.7026 5 13.1078L5.78467 11.7587C6.59387 12.2664 7.31723 12.5203 7.95478 12.5203C8.33894 12.5203 8.65566 12.4369 8.90496 12.27C9.15426 12.1032 9.27891 11.862 9.27891 11.5465C9.27891 11.231 9.13587 10.9807 8.84979 10.7957C8.56371 10.6108 8.16729 10.5183 7.66052 10.5183C7.39079 10.5183 7.01072 10.5872 6.5203 10.725V9.47379L8.18288 8H5.36575Z"
          fill="#1E2946"
        />
      </svg>
    </React.Fragment>
  );
}
